import { useEffect } from "react"
import { RouterProvider } from "react-router-dom"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import queryClient from "api/queryClient"
import router from "router"
import day from "utils/day.ts"
import { useEnvironment } from "utils/environment"

import ErrorBoundary from "components/ErrorBoundary"
import Status from "components/Status"

function App() {
  useEffect(() => {
    if (import.meta.env.PROD) {
      console.log(
        `%c${day(import.meta.env.VITE_BUILD_DATE).format("YYYY-MM-DD HH:mm:ss")}%c ${
          import.meta.env.VITE_LAST_TAG
        }%c ${import.meta.env.VITE_SHA}`,
        "background-color: #FED7D7; color: black; font-size: 12px; font-weight: bold; padding: 2px 8px; border-radius: 2px; margin-right: 4px;",
        "color: white;  margin-right: 4px;",
        "color: white;",
      )
    }
  }, [])

  useEnvironment()

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} fallbackElement={<Status.Spinner />} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default App
